import React, { createContext, useContext, useState } from 'react';

const ShowListEditBoxContext = createContext();

export const ShowListEditBoxProvider = ({ children }) => {
  const [showListEditBox, setShowListEditBox] = useState(false);
  const [targetEditList, setTargetEditList] = useState();

  return (
    <ShowListEditBoxContext.Provider
      value={{
        showListEditBox,
        setShowListEditBox,
        targetEditList,
        setTargetEditList,
      }}
    >
      {children}
    </ShowListEditBoxContext.Provider>
  );
};

export const useShowListEditBoxContext = () =>
  useContext(ShowListEditBoxContext);
